module.exports = __webpack_public_path__ + "img/20210906-1630898385879241.44f9fc0b.jpg";